<script setup lang="ts">
import type { HouseDetails } from '~/types/house/types'

const { house } = defineProps<{
  house: HouseDetails
}>()

const { trackAlgoliaConversion } = useAlgoliaSearchInsights()
const { openScheduler } = useMeetingScheduler()

const handleClick = () => {
  trackAlgoliaConversion(house.id, 'Call')
  openScheduler('product page', house)
}
</script>

<template>
  <div
    class="flex flex-col-reverse gap-4 rounded-sm bg-primary-100 p-6 sm:flex-row"
  >
    <div class="flex grow flex-col justify-start gap-4">
      <h4 class="m-0 font-sansSerif text-base font-semibold">
        {{ $t('house.scheduleACall.title', { houseName: house.name }) }}
      </h4>
      <p class="m-0">
        {{ $t('house.scheduleACall.text') }}
      </p>
      <BaseButton
        class="w-fit"
        type="button"
        color="secondary"
        @click="handleClick"
      >
        {{ $t('house.scheduleACall.cta') }}
      </BaseButton>
    </div>
    <div class="flex min-h-full min-w-32 items-center">
      <BaseNuxtImg
        :alt="$t('house.scheduleACall.cta')"
        class="!size-32 rounded-full"
        src="production/assets/images/schedule-advisor.jpeg"
        sizes="256px"
      />
    </div>
  </div>
</template>
